import SpecialtyEventJoinView from './SpecialtyEventJoinView';

export default SpecialtyEventJoinView;
